import { clientConfig } from "../config";

const HUBSPOT_SCRIPT_ID = "hs-script-loader";

const isHubspotScriptLoaded = () =>
  Boolean(document.getElementById(HUBSPOT_SCRIPT_ID));

/**
 * Loads the HubSpot tracking code if it isn't on the page yet. Without it, events
 * pushed to _hsq just queue up and never reach HubSpot.
 *
 * Shares an element id with useHubSpotChat so the two can't double-inject, and sets
 * loadImmediately:false so this doesn't pop the chat widget open.
 */
const ensureHubspotScriptLoaded = (portalId) => {
  if (isHubspotScriptLoaded()) {
    return;
  }

  window.hsConversationsSettings = {
    ...window.hsConversationsSettings,
    loadImmediately: false,
  };

  const script = document.createElement("script");
  script.id = HUBSPOT_SCRIPT_ID;
  script.src = `//js-eu1.hs-scripts.com/${portalId}.js`;
  script.async = true;
  script.defer = true;
  document.body.appendChild(script);
};

export const identify = (email) => {
  window._hsq = window._hsq || [];
  window._hsq.push([
    "identify",{email},
  ]);

  window._hsq.push(["setPath", window.location.href]);
  window._hsq.push(["trackPageView"]);
};


export const track = (eventType,eventName, props) => {

  if (eventType === 'pv'){
    window._hsq = window._hsq || [];
    window._hsq.push(["setPath", window.location.href]);
    window._hsq.push(["trackPageView"]);
  }

};

/**
 * Sends a HubSpot custom behavioral event. Call this directly rather than through
 * MainTracker.track, which would also fan the event out to Mixpanel/GTM/FB.
 *
 * @param {string} eventNameSuffix - event name without the portal prefix, e.g.
 *                                   "filter_cannabis". HubSpot expects `pe<portalId>_<suffix>`.
 * @param {Record<string, string>} properties - flat map; multi-value enums already joined with ";"
 */
export const trackCustomEvent = (eventNameSuffix, properties = {}) => {
  const portalId = clientConfig.HUBSPOT_PORTAL_ID;
  if (!portalId || !eventNameSuffix) {
    window.clientLogger?.warn("HubSpot custom event skipped: missing portal id or event name", {
      code: "hubspot_custom_event_missing_name",
      portalId: portalId || null,
      eventNameSuffix: eventNameSuffix || null,
    });
    return;
  }

  const eventName = `pe${portalId}_${eventNameSuffix}`;

  // Load the tracking code first: the queue below only drains once it is present.
  ensureHubspotScriptLoaded(portalId);

  window._hsq = window._hsq || [];
  window._hsq.push([
    "trackCustomBehavioralEvent",
    {
      name: eventName,
      properties,
    },
  ]);
};
